import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PromocionesEccomerce } from '../ecommerce-generico/class/promociones-class';

@Injectable({
  providedIn: 'root'
})
export class CarruselPromocionesService {

  private carrouselSlide: BehaviorSubject<PromocionesEccomerce[]> = new BehaviorSubject([]);
  private slidesArray: any[] = [];
  private slidesArrayObservable: BehaviorSubject<any[]> = new BehaviorSubject([]);

  reiniciarSlides(): void {
    this.slidesArray = [];
  }

  emitirSlide(slide: PromocionesEccomerce[]): void {
    this.carrouselSlide.next(slide);
  }

  getCarrouselSlides(): void {
    this.carrouselSlide.subscribe(data => {
      if (data.length != 0) {
        if (this.slidesArray.length == 0) {
          this.slidesArray.push(data[0]);
        } else {
          if (!this.containsSlide(data[0], this.slidesArray)) {
            this.slidesArray.push(data[0]);
          }
        }
      }
      this.slidesArrayObservable.next(this.slidesArray);
    });
  }

  getSlidesProvider(): Observable<any[]> {
    return this.slidesArrayObservable.asObservable();
  }

  containsSlide(obj, list): boolean {
    for (let i = 0; i < list.length; i++) {
      if (list[i].imagen == obj.imagen) {
        return true;
      }
    }
    return false;
  }
}
